import GameCanvas from "../components/jetdog/GameCanvas";

export default function GamePreview() {
  return (
    <div className="min-h-screen bg-[var(--jd-bg)] p-6">
      <h1 className="font-display text-3xl uppercase mb-4">Game Preview (2D)</h1>
      <div className="max-w-5xl">
        <GameCanvas onGameOver={(c, d) => console.log("game over", c, d)} />
      </div>
    </div>
  );
}
